//--------------------------------------------------------------------All Imports---------------------------------------------------------------------------//
import React from "react";
//--------------------------------------------------------------------All Imports---------------------------------------------------------------------------//

function ErrorPage() {
  return <div>ErrorPage</div>;
}

export default ErrorPage;
